import styled from 'styled-components';
import ArrowIcon from '@catalogo/theme-svg/arrow.svg';

const BackButtonStyled = styled.button<{ fontSize?: number }>`
  font-style: normal;
  font-weight: normal;
  font-size: ${({ fontSize }) => fontSize}px;
  color: #666;
  line-height: 21px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  margin-left: 5px;
`;

const Arrow = styled(ArrowIcon)`
  fill: #666;
  width: 8px;
  height: 8px;
  background: inherit;
  transform: rotate(90deg);
`;

const Wrapper = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin};
  display: flex;
  align-items: center;
`;

export default BackButtonStyled;
export { BackButtonStyled, Arrow, Wrapper };
